import React, { Fragment, useEffect, useState, useRef } from 'react';
import {
  Slide,
  IconButton,
  ClickAwayListener,
  InputBase,
  Button,
  Grid,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Paper,
  Tabs,
  Tab,
  Box,
  Modal,
  Divider,
  MenuItem,
  FormControl,
  InputLabel,
  Select,
  TextField,
  FormControlLabel,
  RadioGroup,
  Radio,
  Checkbox,
  ListItemText,
  OutlinedInput,
  Pagination,
  CircularProgress,
  Link

} from '@mui/material';
import Autocomplete, { createFilterOptions } from '@mui/material/Autocomplete';
import { useNavigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { styled } from '@mui/material/styles';
import { Icon } from '@iconify/react';
import moment from 'moment';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { ToastContainer, toast } from 'react-toastify';
import dayjs from 'dayjs';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { Helmet } from 'react-helmet-async';
import Iconify from '../components/iconify';

import MyCustomUploadAdapterPlugin from './customEditor/customEditor';

// import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import Scrollbar from '../components/scrollbar/Scrollbar';
import { Api, UploadFile } from '../webservices';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const styleSkillset = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  // width: { xs: '60%', sm: '50%' },
  width: '50%',
  bgcolor: 'background.paper',
  border: '3px solid #3C6BA5',
  boxShadow: 24,
  p: 3,
  borderRadius: 3,
};

const styleSkillset12 = {
  position: 'absolute',
  top: "8%",
  left: "9.5%",
  width: '80%',
  minHeight: '85%',
  maxHeight: '85%',
  bgcolor: 'background.paper',
  border: '1px solid #3C6BA5',
  boxShadow: 10,
  p: 3,
  borderRadius: 1,
  overflowY: 'auto',
};

const tablebg = 'rgba(82, 130, 190, 0.08)';
const filter = createFilterOptions();

const Foxearch = () => {
  const navigate = useNavigate()
  const [hideBtn, setHideBtn] = useState()
  const [jobTit, setJobTit] = useState()
  const [jobDSkills, setJobDSkills] = useState()
  const [jobSkills, setJobSkills] = useState()
  const [consultModal, setConsultModal] = useState(false)
  const [cityMatch, setCityMatch] = useState()
  const [stateCodeMatch, setSateCodeMatch] = useState()
  const [stateMatch, setStateMatch] = useState()
  const [altMatch, setAltMatch] = useState()
  const [clientName, setClientName] = useState()
  const location = useLocation();
  const row = location?.state?.row

  const combinedSkills = [
    // ...(jobDSkills?.map(skill => skill.desiredSkill) || []),
    ...(row?.skillWithExp?.map(skill => skill?.mustHaveSkill)?.filter(Boolean) || [])
  ];

  // console.log("row", row)
  // console.log("combinedSkills", combinedSkills)

  useEffect(() => {

    if (row) {
      setAltMatch(row?.altJobTitle);
      setJobSkills(combinedSkills);
      setJobTit(row?.jobTitle);
      setCityMatch(row?.city)
      // setJobDSkills(row?.desiredSkillsWithExp)
      setSateCodeMatch(row?.stateCode)
      setStateMatch(row?.state)
      setClientName(row?.endClientOrImpPartner)
      getConsultData('', row?.jobTitle, combinedSkills, row?.altJobTitle, row?.endClientOrImpPartner?.trim());
    }
  }, [row]);

  const optionsDate = {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    // timeZone: 'UTC'
  };

  const getConsultData1 = () => {
    getConsultData('', row?.jobTitle, combinedSkills, row?.altJobTitle, row?.endClientOrImpPartner?.trim())

  }

  const getLocalisedData1 = () => {
    getLocalisedData('', row?.jobTitle, combinedSkills, row?.altJobTitle)
  }

  // const openConsultModal = (jobTitle, dSkills, skills, city, stateCode, altJobTitle, state) => {
  //   setAltMatch(altJobTitle)
  //   setJobSkills(skills)
  //   setJobTit(jobTitle)
  //   setCityMatch(city)
  //   setJobDSkills(dSkills)
  //   setSateCodeMatch(stateCode)
  //   setStateMatch(state)
  //   setConsultModal(true)
  //   setValuee("consult")
  // }

  //  console.log("jobDSlills", jobDSkills)
  //   console.log("jobSkills", jobSkills)

  //   console.log("Combined Skills:", combinedSkills);

  const closeConsultModal = () => setConsultModal(false)
  const [valuee, setValuee] = React.useState('consult');
  const [consultData, setConsultData] = useState([])
  const [loading, setLoading] = useState('')
  const [tableCount, setTableCount] = useState()
  const [pageNumber, setPageNumber] = useState(1)

  const localisedAll = () => {
    getLocalisedData2('', row?.jobTitle, combinedSkills, row?.altJobTitle, valuee)
  }

  const getLocalisedData2 = (value, jobTit1, combinedSkills1, altMatch1, valuee) => {
    // alert(valuee)
    setCheckedItems({});
    // setConsultData([]);
    setTableDataCon([]);
    setLoading("Loading...");
    setTableCount("");

    const token = localStorage.getItem("token");
    const body = {
      jobTitle: jobTit1 || jobTit,
      skill: combinedSkills1 || combinedSkills,
      page: value || 1,
      limit: "50",
      altJobTitle: altMatch1 || altMatch,
    };

    Api("resume/jobPopUpLocalised", "POST", body, token).then((Response) => {
      if (Response.status === 200) {
        if (Response.data.result) {
          setTableCount(Response.data.count);
          const totalPage = Math.ceil(Response.data.count / 35);
          setTableDataCon(Response.data.result);
          console.log("----------------------cityMatch----", cityMatch)
          const Cities = Response.data.result?.filter(
            (item) => (item.recruitorAppId?.city === cityMatch || item?.city === cityMatch) && (item?.recruitorAppId?.state === stateMatch || item?.state === stateMatch)
          );
          console.log("Cities======>",Cities)
          const NoCity = Response.data.result.filter(
            (item) => item.recruitorAppId?.city !== cityMatch || item?.city !== cityMatch
          );

          const States = NoCity.filter(
            (item) => item?.stateCode === stateCodeMatch
          ); 

          const States1 = NoCity.filter(
            (item) => item.stateCode !== stateCodeMatch
          );

          const Reloca = States1.filter(
            (item) => item.recruitorAppId?.relocation || item?.relocation === "yes"
          );

          const Allover = States1.filter(
            (item) => item.recruitorAppId?.relocation || item?.relocation !== "yes"
          );

          if (valuee === "localised" && Cities.length > 0) {
            setConsultData(Cities);
            setHideBtn(Cities.length);
            setLoading("");
          } else if (valuee === "statewise" && States.length > 0) {
            setConsultData(States);
            setLoading("");
          } else if (valuee === "relocation" && Reloca.length > 0) {
            setConsultData(Reloca);
            setHideBtn(Reloca.length);
            setLoading("");
          } else if (valuee === "allover" && Allover.length > 0) {
            setConsultData(Allover);
            setHideBtn(Allover.length);
            setLoading("");
          } else {
            setConsultData([]);
            setLoading("No data found");
          }

          setLoading("");
        } else {
          setLoading("No data found");
        }
      } else {
        setLoading("");
      }
    });
  }

  const getConsultData = (value, jobTit1, combinedSkills1, altMatch1, client1) => {
    setHideBtn('')
    setConsultData([])
    setLoading("Loading...")
    setTableCount('')
    getLocalisedData('', jobTit1, combinedSkills1, altMatch1)
    const token = localStorage.getItem('token');
    const body = {
      "jobTitle": jobTit1 || jobTit,
      "skill": combinedSkills1 || combinedSkills,
      "page": value || 1,
      "limit": "50",
      "altJobTitle": altMatch1 || altMatch,
      "clientName": client1 || clientName?.trim()
    }

    Api('bench/jobPopupConsultant', 'POST', body, token).then((Response) => {
      if (Response.status === 200) {
        if (Response.data.result && Response.data.result.length > 0) {
          setConsultData(Response.data?.result);
          setTableCount(Response.data.count)
          setHideBtn(Response.data.result.length)
          const totalPage = Math.ceil(Response.data.count / 35)
          // setPages(totalPage)
          setLoading('');
        } else {
          setLoading('No data found');
        }
      } else {
        setLoading("No data found");
      }
    }).catch(error => {
      // setLoading("No data found");

    });
  };

  const [hideTab, setHideTab] = useState(false)
  const [TableDataCon, setTableDataCon] = useState([])

  const getLocalisedData = (value, jobTit1, combinedSkills1, altMatch1) => {
    setCheckedItems({})
    setConsultData([])
    setTableDataCon([])
    setLoading("Loading...")
    setTableCount('')
    const token = localStorage.getItem('token');
    const body = {
      "jobTitle": jobTit1 || jobTit,
      "skill": combinedSkills1 || combinedSkills,
      "page": value || 1,
      "limit": "50",
      "altJobTitle": altMatch1 || altMatch
    }
    Api('resume/jobPopUpLocalised', 'POST', body, token).then((Response) => {
      if (Response.status === 200) {
        if (Response.data.result) {
          console.log("Cities======>",Response.data.result)
          setTableDataCon(Response.data.result)
          // setConsultData(Response.data.result)
          setTableCount(Response.data.count)
          const totalPage = Math.ceil(Response.data.count / 35)
          // setPages(totalPage)
          // setHideTab()
          // setHideTab(Response.data.result?.otherData)
          setLoading('')
        } else {
          setLoading('No data found');
        }
      } else {
        setLoading("")
        // handleOpenn()
        // toast.warn(Response.data.error, +'!');
      }
    });
  };

  const [moveToData, setMoveToData] = useState()

  const selectTab = (tab) => {
    // alert("nn")
    // console.log("tab=====>>>>". tab)
    setCheckedItems({})
    setValuee(tab)
    // setMoveToData(tab)
    // const Cities = TableDataCon?.filter(item => item.recruitorAppId?.city === cityMatch && item?.recruitorAppId?.state === stateMatch);
    const Cities = TableDataCon?.filter(item => (item.recruitorAppId?.city === cityMatch || item.city === cityMatch) && (item?.recruitorAppId?.state === stateMatch || item?.state === stateMatch));
    // console.log('Cities===>>>', Cities);
    // console.log('cityMatch===>>>', cityMatch);
    // console.log('stateMatch===>>>', stateMatch);
    if (tab === 'localised') {
      if (Cities.length > 0) {
        setConsultData(Cities);
        setHideBtn(Cities.length)
        setLoading('');
      } else {
        setConsultData([]);
        setLoading('No data found');
      }
    }
    const NoCity = TableDataCon.filter(item => item.recruitorAppId?.city !== cityMatch || item?.city !== cityMatch);
    // console.log('NoCity===>>>', NoCity);
    const States = NoCity.filter(item => item?.stateCode === stateCodeMatch);
    // console.log('States===>>>', States);

    if (tab === 'statewise') {
      if (States.length > 0) {
        setConsultData(States);
        setLoading('');
      } else {
        setConsultData([]);
        setLoading('No data found');
      }
    }
    const States1 = NoCity.filter(item => item.stateCode !== stateCodeMatch);
    // console.log("States1", States1)
    const Reloca = States1.filter(item => (item?.recruitorAppId?.relocation === "yes" || item?.relocation === "yes"));
    // console.log('Reloca===>>>', Reloca);

    if (tab === 'relocation') {
      if (Reloca.length > 0) {
        setConsultData(Reloca);
        setHideBtn(Reloca.length)
        setLoading('');
      } else {
        setConsultData([]);
        setLoading('No data found');
      }
    }
    const Allover = States1.filter(item => (item.recruitorAppId?.relocation !== "yes" || item?.relocation !== "yes"));
    // const Allover = States1.filter(item => item.reallocate !== "yes");
    // console.log('Allover===>>>', Allover);

    if (tab === 'allover') {
      if (Allover.length > 0) {
        setConsultData(Allover);
        setHideBtn(Allover.length)
        setLoading('');
      } else {
        setConsultData([]);
        setLoading('No data found');
      }
    }
  }

  // console.log("hideTab", hideTab)

  const [checkedItems, setCheckedItems] = useState({});

  //   const handleCheck = (itemId, email) => {
  //   const isChecked = !checkedItems[itemId];
  // // console.log("checked")
  //   if (isChecked) {
  //     setBccEmail((prev) => {
  //       const alreadyExists = prev.some((item) => item.title === email);
  //       if (!alreadyExists) {
  //         return [...prev, { title: email }];
  //       }
  //       return prev;
  //     });
  //   } else {
  //     setBccEmail((prev) => prev.filter((item) => item.title !== email));
  //   }

  //   setCheckedItems((prev) => ({ 
  //     ...prev,
  //     [itemId]: isChecked,
  //   }));
  // }; 

  // const handleCheck = (itemId, email, name) => {
  //   const isChecked = !checkedItems[itemId];

  //   if (isChecked) {
  //     setBccEmail((prev) => {
  //       const alreadyExists = prev.some((item) => item.email === email);
  //       if (!alreadyExists) {
  //         return [...prev, { name, email }];
  //       }
  //       return prev;
  //     });
  //   } else {
  //     setBccEmail((prev) => prev.filter((item) => item.email !== email));
  //   }

  //   setCheckedItems((prev) => ({
  //     ...prev,
  //     [itemId]: isChecked,
  //   }));
  // };

//   const handleCheck = (itemId, email, name) => {
//   const isChecked = !checkedItems[itemId];
 
//   const formattedName = (name || "")
//     .split(" ")
//     .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
//     .join(" ");
 
//   if (isChecked) {
//     setBccEmail((prev) => {
//       const alreadyExists = prev.some((item) => item.email === email);
//       if (!alreadyExists) {
//         return [...prev, { name: formattedName, email }];
//       }
//       return prev;
//     });
//   } else {
//     setBccEmail((prev) => prev.filter((item) => item.email !== email));
//   }
 
//   setCheckedItems((prev) => ({
//     ...prev,
//     [itemId]: isChecked,
//   }));
// }

const handleCheck = (itemId, email, name) => {
  const isChecked = !checkedItems[itemId];

  const formattedName = (name || "")
    .split(" ")
    .map(
      (word) =>
        word?.charAt(0)?.toUpperCase() + word?.slice(1)?.toLowerCase()
    )
    .join(" ");

  setBccEmail((prev) => {
    let updated;  

    if (isChecked) {
      const alreadyExists = prev?.some((item) => item.email === email);
      if (!alreadyExists) {
        updated = [...prev, { name: formattedName, email }];
      } else {
        updated = prev;
      }
    } else {
      updated = prev.filter((item) => item.email !== email);
    }

    if (updated?.length > 0) {
      setRecipientEmail(updated[0]?.email);
    } else {
      setRecipientEmail("");
    }

    return updated;
  });

  setCheckedItems((prev) => ({
    ...prev,
    [itemId]: isChecked,
  }));
};

  // const handleSelectAll = () => {
  //   const allChecked = consultData?.length > 0 && consultData?.every(item => checkedItems[item._id]);
  //   const newCheckedItems = consultData?.reduce((acc, item) => {
  //     acc[item._id] = !allChecked;
  //     return acc;
  //   }, {});

  //   setCheckedItems(newCheckedItems);
  // };

  // const handleSelectAll = () => {
  //   const allChecked = consultData?.length > 0 && consultData?.every(item => checkedItems[item._id]);
  //   const newCheckedItems = consultData?.reduce((acc, item) => {
  //     acc[item._id] = !allChecked;
  //     return acc;
  //   }, {});

  //   setCheckedItems(newCheckedItems);
  // };

  const allChecked = consultData?.length > 0 && consultData?.every(item => checkedItems[item._id]);

  const [bccEmail, setBccEmail] = useState([]);

  //     const handleSelectAll = () => { 
  //       setBccEmail([])
  //      if(allChecked){
  //        setBccEmail([])
  //      } else {
  //  setBccEmail(consultData?.map((item) => ({ title: item?.email })) || []);
  //      }
  //      const newCheckedItems = consultData?.reduce((acc, item) => {
  //        acc[item._id] = !allChecked;
  //        return acc;
  //      }, {}); 
  //      setCheckedItems(newCheckedItems);
  //    }; 

  // const handleSelectAll = () => {
  //   if (allChecked) {
  //     setBccEmail([]);
  //   } else {
  //     setBccEmail(
  //       consultData?.map((item) => ({
  //         // name: item?.fullName || "",
  //         name: (item?.fullName || "")
  //     .split(" ")
  //     .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
  //     .join(" "),
  //         email: item?.email || ""
  //       })) || []
  //     );
  //   }

  //   const newCheckedItems = consultData?.reduce((acc, item) => {
  //     acc[item._id] = !allChecked;
  //     return acc;
  //   }, {});
  //   setCheckedItems(newCheckedItems);
  // };

  const handleSelectAll = () => {
  if (allChecked) {
    
    setBccEmail([]);
    setRecipientEmail("");
  } else {
   
    const formattedEmails =
      consultData?.map((item) => ({
        name: (item?.fullName || "")
          .split(" ")
          .map(
            (word) =>
              word?.charAt(0)?.toUpperCase() + word?.slice(1)?.toLowerCase()
          )
          .join(" "),
        email: item?.email || "",
      })) || [];

    setBccEmail(formattedEmails);

    if (formattedEmails?.length > 0) {
      setRecipientEmail(formattedEmails[0]?.email);
    }
  }

  const newCheckedItems = consultData?.reduce((acc, item) => {
    acc[item._id] = !allChecked;
    return acc;
  }, {});
  setCheckedItems(newCheckedItems);
};

  const [loadingMov, setLoadingMov] = useState(false);
  const isButtonDisabled = Object?.values(checkedItems)?.every(checked => !checked);

  const moveTo = () => {
    setLoadingMov(true)
    const token = localStorage.getItem('token');
    consultData?.forEach(item => {
      // console.log("item======>", item)
      if (checkedItems[item._id]) {
        // if (valuee === "consult") {
        //   moveToWorksheet(item, token)
        //   // moveToBench(item?.benchAppId, token)
        // } else {
        //   moveToWorksheet(item, token);
        // }
        //         if (valuee !== "consult") {
        //   if (item.dataFrom === "foxearchDB") {
        //     moveToWorksheet(item.recruitorAppId, token);
        //   } else {
        //     moveToWorksheet(item, token);
        //   }
        // } else {
        //    if (item.dataFrom === "foxearchDB") {
        //     moveToWorksheet(item.benchAppId, token);
        //   } else {
        //     moveToWorksheet(item, token);
        //   } 
        // }

        const appId = item.dataFrom === "foxearchDB"
          ? valuee !== "consult"
            ? item.recruitorAppId
            : item.benchAppId
          : item;

        moveToWorksheet(appId, token);

      }
    });
    setCheckedItems({})
  };

  const moveToWorksheet = (row, token) => {
    const body = {
      "newCV": "no",
      email: row.email || '',
      fullName: row.fullName,
      jobTitle: row.jobTitle,
      phone: row.phone,
      currentCompany: row.currCompany,
      skill: row.skill,
      visaType: row.visaType,
      taxTerm: row.taxTerm,
      chargeType: row.chargeType,
      expectedCompensation: row.expectedCompensation,
      linkedinUrl: row.linkedinUrl,
      reallocate: row.reallocate,
      resumeUrl: row.resumeUrl,
      jobId: row.jobid,
      note: row.notes,
      zipcode: row.zip,
      "additionalResumes": row.additionalResumes,
      status: row.status,
      userStatus: row.userStatus,
      dataFrom: "foxearchdb",
      city: row.city,
      state: row.state,

      "stateCode": row.stateCode,
    };

    Api(`resume/create_resume`, 'POST', body, token)
      .then((response) => {
        if (response.status === 200 && response.data.code === 200) {
          toast.success('Data successfully moved!');
          setLoadingMov(false)
          // selectTab(moveToData)
          //   setValuee(moveToData)
        } else {
          toast.warn("A resume with the same email already exists");
          setLoadingMov(false)

        }
      })
      .catch(error => {
        // console.error('API error:', error);
        // toast.error("An error occurred while moving data.");
      });
  };

  const moveToBench = (row, token) => {
    if (!row.email) {
      toast.error("Email is required");
      return;
    }
    if (!row.fullName) {
      toast.error("Full name is required");
      return;
    }
    if (!row.jobTitle) {
      toast.error("Job title is required");
      return;
    }
    const body = {
      dataFrom: "foxearchdb",
      email: row.email,
      fullName: row.fullName,
      jobTitle: row.jobTitle,
      phone: row.phone,
      currentCompany: row.currCompany,
      skill: row.skill,
      visaType: row.visa,
      visaTransfer: row.visaTrn,
      taxTerm: row.tax,
      chargeType: row.comType,
      expectedCompensation: row.expectedCom,
      cityOrZipcode: row.city,
      linkedinUrl: row.linkedinUrl,
      reallocate: row.reloc,
      zipcode: row.zip,
      stateCode: row.stateCode,
      resumeUrl: row?.resumeFile?.resumeFileUrl,
      state: row.state,
      visaFile: row.pdffileVisa,
      otherFile: row.pdffileOtherDoc,
      i94_File: row.pdffile94,
      DL_File: row.pdffileDL,
      note: row.notes,
      userStatus: row.userStatus,
      country: row.country,
      validity: row.validity,
      DOB: row.dateofbirth,
      summary: row.summary,
      experienceInYear: row.yearExp
    };

    Api(`bench/addNewBenchProspect`, 'POST', body, token)
      .then((response) => {
        // console.log('=====bench==========>>>>>>>', response);
        if (response.status === 200) {
          if (response.data.code === 200) {
            setLoadingMov(false);
            toast.success('Data successfully moved!');
            getConsultData();
            setValuee("consult");

          } else {
            toast.warn("A bench worksheet with the same email already exists");
          }
        } else {
          toast.warn("A bench worksheet with the same email already exists");
        }
      })
      .catch((err) => {
        // console.log('===========', err);
        // toast.warn("A bench worksheet with the same email already exists");
      })
      .finally(() => {
        setLoadingMov(false);
      });
  };

  useEffect(() => {
    getTemplList()
    // getSkills();
  }, []);

  const [tempskill, setTempskill] = useState([]);
  const [addedSkill, setAddedSkill] = useState([])

  const getSkills = async () => {
    const token = localStorage.getItem('token');
    Api(`resume/get_skills/${"other"}`, 'GET', '', token)
      .then((response) => {
        // console.log('=========getSkills======>>>>>>>', response.data);
        if (response.data.code === 200) {
          if (response.data.result.length !== 0) {
            response.data?.result?.map((item) => {
              return tempskill?.push({ title: item?.skillName });
            });
            // setSkill(tempskill);
            setAddedSkill(tempskill)
            // console.log('===value skilll========', JSON.stringify(skill));
          } else {
            // setSkill([{ title: '' }]);
          }
        } else {
          toast.warn(response.data.message, +'!');
        }
      })
      .catch((err) => {
        // console.log('===========', err);
        toast.error(err, +'!');
      });
  };

  // const [pages, setPages] = useState(null)

  const handlePage = (valuee) => {
    setPageNumber(pageNumber + 1);
    // console.log(value)
    if (valuee === "consult") {
      // setPageNumber(pageNumber+1)
      getConsultData(pageNumber + 1)
    } else {
      getLocalisedData(pageNumber + 1)
      // setPageNumber(pageNumber+1)
      selectTab(valuee)
    }
    // getJobs(currentTab, value)
  };

  // console.log("PageNumber", pageNumber)
  // console.log("hideBtn", hideBtn)

  const [selectedDropdownValue, setSelectedDropdownValue] = useState('consult');

  const handleChangeDrop = (event) => {
    // console.log("event", event);
    const selectedTab = event.target.value;
    setSelectedDropdownValue(selectedTab);
  }

  const Funcc = () => {
    const selectedTab = selectedDropdownValue;
    if (selectedTab === 'consult') {
      getConsultData()
      selectTab(selectedTab);
    } else if (selectedTab === 'localised') {
      selectTab(selectedTab);
    } else if (selectedTab === 'statewise') {
      selectTab(selectedTab);
    } else if (selectedTab === 'relocation') {
      selectTab(selectedTab);
    } else if (selectedTab === 'allover') {
      selectTab(selectedTab);
    }
  }

  const [modalOpen, setModalOpen] = useState(false);

  const handleOpenModal = (email) => {
    // setSelectedCandidateId(id);
    // setRecipientEmail(email)
    setModalOpen(true);
    // alert(`Selected Candidate ID: ${id}`);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
  };

  const [greeting, setGreeting] = useState('')
  const [recipientEmail, setRecipientEmail] = useState(row.email);
  const [subject, setSubject] = useState('');
  const [emailBody, setEmailBody] = useState('');
  const [ccEmail, setCcEmail] = useState([]);

  const [base64, setBase64] = useState([])
  const [fileName, setFileName] = useState('')
  const [fileType, setFileType] = useState('')
const [attachment, setAttachment] = useState('')

  const FileChange = (event) => {
    const file = event.target.files[0];
    // console.log("file---", event.target.files)
    if (file) {
      setFileName(file.name)
      setFileType(file.type)
      convertFileToBase64(file);
       uploadAttach(file)
    } else {
      toast.warn('No file selected!');
    }
  };

  const uploadAttach = async (file) => {
            const token = localStorage.getItem('token');
            const formData = new FormData();
            formData.append('document', file);
            formData.append('directoryName', 'profile');
            try {
                const response = await UploadFile('resume/upload_resume', formData, token);
                if (response.status === 200 && response.data.code === 200) {
                    setAttachment(response.data.filePath)
                } else {
                    //   toast.warn(response.data.status + '!');
                }
            } catch (error) {
                // toast.warn('Error uploading the image!');
            }
        };

  const convertFileToBase64 = (file) => {
    const reader = new FileReader();
    reader.onloadend = () => {
      setBase64(reader.result);
      // console.log("base64",reader.result)
    };
    reader.readAsDataURL(file);
  };

  const sign = localStorage.getItem("sign");

  const [loadingSend, setLoadingSend] = useState(false)

  const sendBulkEmail = async () => {
     setLoadingSend(true)       
    const body = {
      "subject": subject,
      "attachment":attachment,
       "fileName":fileName,
      "others":
        // [
        // {
        //   "name": "",
        //   "email": ""
        // }
        bccEmail, 
      // ],
      "mailBody":emailBody
//       "mailBody":`${emailBody}<br/>${sign?.replace(
//     /<figure[^>]*>(.*?)<\/figure>/gi,
//     (_, innerContent) => `<p>${innerContent}</p>`
//   )
// }`
    };
    const token = localStorage.getItem('token');
    Api(`email/send_bulk_mail`, 'POST', body, token)
      .then((response) => {
        // console.log('====rec ====', response);
        if (response.status === 200) {
           handleCloseModal()
                    toast.success(response.data.message);
                    setLoadingSend(false)
        }
      })
      .catch((err) => {
        toast.error(err, +'!');
      });
  };

  const [tempList, setTempList] = useState([])
  
   const getTemplList = () => {
      const token = localStorage.getItem('token');
      // console.log("token ===>>>>> ",token)
      Api('email/getEmailTemplateList', 'GET', '', token)
        .then((response) => {
          // console.log('Response:---------', response);
          if (response.status === 200) {
            if (response.data.code === 200) {
              //  console.log("hhh")
  
            } else {
              // console.log('data:', response.data.message);
            }
          }
          setTempList(response.data.result);
        })
        .catch((error) => {
          console.error("Error:", error);
        });
    };

   const handleTemplateSelect = (item) => {
    if (item && item.template && item.template.length > 0) {
      setGreeting(item.template[0].greeting)
      setSubject(item.template[0].subject)
      setEmailBody(item.template[0].emailBody)
    }
  };

  return (
    <>
      <Helmet>
        <title> Foxearch | Foxearch </title>
      </Helmet>

      <ToastContainer />

      <div style={{ display: 'flex', alignItems: 'center', left: 115, right: 0 }}>
        <FormControl size="small" sx={{
          width: '25%',
          // borderRadius: '10px',
          border: "none",
          marginLeft: '4px',
          backgroundColor: "white",
          // border: '1px solid "#3C6BA5"', 
          // border: '1px solid #1E74B3',
          overflow: 'hidden',
          marginTop: -18,
        }}>
          <Select
            value={selectedDropdownValue}
            onChange={handleChangeDrop}
            size="small"
            className='dash_sr'
            sx={{
              borderRadius: '10px',
              border: '1px solid #1E74B3',
              '&:focus-visible': {
                borderRadius: '10px',
                border: '1px solid #1E74B3',
              },
            }}

            MenuProps={{
              disableScrollLock: true,
            }}
          >
            <MenuItem value='consult'>Consultants</MenuItem>
            <MenuItem value='localised'>Localised</MenuItem>
            <MenuItem value='statewise'>Statewise</MenuItem>
            <MenuItem value='relocation'>Relocation</MenuItem>
            <MenuItem value='allover'>All Over</MenuItem>

          </Select>
        </FormControl>

        <Button color="custom" variant="contained" size="small"
          sx={{ ml: 1.6, mt: -18 }}
          onClick={() => Funcc()}
        >
          Search
        </Button>
      </div>

      <Iconify icon="ion:arrow-back" fontSize={25} sx={{
        cursor: 'pointer', color: 'text.secondary', fontSize: '0.9rem',
        fontWeight: '600', mr: 1, mt: -1
      }} onClick={() => navigate(-1)} />
      <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={2}>
        <Box sx={{}}>
          <Typography variant="h5" color="textSecondary">
            Foxearch
          </Typography>
        </Box>
        <Stack direction="row" spacing={1} justifyContent="flex-end" sx={{ ml: 'auto', mb: 0.6 }}>
          <Button color="custom" variant="contained" size="small" onClick={() => handleSelectAll()}>
            {allChecked ? "Deselect All" : "Select All"}
          </Button>
          <Button color="custom" variant="contained" size="small"

            onClick={() => handleOpenModal(consultData[0]?.email)}>
            Email
          </Button>
          <Button color="custom" variant="contained" size="small" disabled={loadingMov || isButtonDisabled || valuee === 'consult'}
            onClick={() => moveTo()}>
            {loadingMov ? <CircularProgress size={24} /> : 'Add to Worksheet'}
          </Button>
        </Stack>
      </Stack>

      <Stack sx={{
        flexDirection: 'row', gap: 2, cursor: 'pointer', alignItems: 'center', width: '100%', justifyContent: 'flex-start',
        mb: 0.5,
      }}>
        <Stack
          sx={[
            { flexDirection: 'row', alignItems: 'center' },
            valuee === 'consult' ? { borderBottom: 3, color: 'text.secondary' } : { color: 'text.textG' },
          ]}
          onClick={() => {
            setPageNumber(1)
            setValuee('consult');
            getConsultData()
          }}
        >
          <Iconify icon="gridicons:multiple-users" fontSize={17} />
          <Typography variant="tabs" sx={{ ml: 1 }}>
            Consultants
          </Typography>
        </Stack>

        <Stack
          sx={[
            { flexDirection: 'row', ml: 1, alignItems: 'center' },
            valuee === 'localised' ? { borderBottom: 3, color: 'text.secondary' } : { color: 'text.textG' },
          ]}
          onClick={() => {
            selectTab("localised")
            setPageNumber(1)
          }}
        >
          <Iconify
            icon="icon-park-outline:local"
            fontSize={17}
            color={valuee === 'localised' ? '#B7950B' : 'text.textG'}
          />
          <Typography variant="tabs" sx={{ ml: 1 }}>
            Localised
          </Typography>
        </Stack>

        <Stack
          sx={[
            { flexDirection: 'row', ml: 1, alignItems: 'center' },
            valuee === 'statewise' ? { borderBottom: 3, color: 'text.secondary' } : { color: 'text.textG' },
          ]}
          onClick={() => {
            selectTab("statewise")
            setPageNumber(1)
          }}
        >
          <Iconify icon="mdi:sign-real-estate" fontSize={17}
            color={valuee === 'statewise' ? '#F4D03F' : 'text.textG'}
          />
          <Typography variant="tabs" sx={{ ml: 1 }}>
            Statewise
          </Typography>
        </Stack>

        <Stack
          sx={[
            { flexDirection: 'row', ml: 1, alignItems: 'center' },
            valuee === 'relocation' ? { borderBottom: 3, color: 'text.secondary' } : { color: 'text.textG' },
          ]}
          onClick={() => {
            selectTab("relocation")
            setPageNumber(1)
          }}
        >
          <Iconify
            icon="mdi:aeroplane"
            fontSize={17}
            color={valuee === 'relocation' ? '#2ECC71' : 'text.textG'}
          />
          <Typography variant="tabs" sx={{ ml: 1 }}>
            Relocation
          </Typography>
        </Stack>

        <Stack
          sx={[
            { flexDirection: 'row', ml: 1, alignItems: 'center' },
            valuee === 'allover' ? { borderBottom: 3, color: 'text.secondary' } : { color: 'text.textG' },
          ]}
          onClick={() => {
            selectTab("allover")
            setPageNumber(1)
          }}
        >
          <Iconify icon="subway:world" fontSize={13}
            color={valuee === 'allover' ? '#CB4335' : 'text.textG'}
          />
          <Typography variant="tabs" sx={{ ml: 1 }}>
            All Over
          </Typography>
        </Stack>

      </Stack>

      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 650 }} aria-label="simple table">

          <TableHead>
            <TableRow sx={{ justifyContent: 'flex-start', backgroundColor: 'text.secondary' }}>

              {valuee !== "consult" ? (
                <TableCell sx={{ p: 1, py: 0.5, color: 'white', width: '20%', paddingLeft: 6 }}>
                  Date</TableCell>
              ) : (
                <TableCell sx={{ p: 1, py: 0.5, color: 'white', width: '17%', paddingLeft: 6 }}>
                  Date</TableCell>
              )}

              {valuee !== "consult" ? (
                <TableCell sx={{ p: 1, py: 0.5, color: 'white', width: '22%', paddingLeft: 1.8 }}>
                  Detail
                </TableCell>
              ) : (<TableCell sx={{ p: 1, py: 0.5, color: 'white', width: '17%', paddingLeft: 1.8 }}>
                Detail
              </TableCell>)}

              {valuee !== "consult" ? (
                <TableCell
                  sx={{ p: 1, py: 0.5, color: 'white', width: '28%', paddingLeft: 1.8 }}
                >
                  Contact Details
                </TableCell>
              ) : (<TableCell
                sx={{ p: 1, py: 0.5, color: 'white', width: '19%', paddingLeft: 1.8 }}
              >
                Contact Details
              </TableCell>)}

              {valuee !== "consult" ? (
                <TableCell sx={{ p: 1, py: 0.5, color: 'white', width: '19%' }}>
                  Skills
                </TableCell>
              ) : (
                <TableCell sx={{ p: 1, py: 0.5, color: 'white', width: '13%' }}>
                  Skills
                </TableCell>
              )}

              <TableCell sx={{ p: 1, py: 0.5, color: 'white', width: '12%' }}>
                Visa & Terms
              </TableCell>

              {valuee === "consult" && (

                <TableCell sx={{ p: 1, py: 0.5, color: 'white', width: '10%' }}>Summary</TableCell>
              )}

            </TableRow>
          </TableHead>

          {consultData?.map((item, index) => (
            <ConsultRow
              key={item._id}
              index={index}
              row={item}
              checked1={checkedItems[item._id]}
              handleCheck1={() => handleCheck(item._id, item?.email, item?.benchAppId?.fullName || item?.recruitorAppId?.fullName)}
              // handleCheck1={() => handleCheck(item._id, item?.email, item?.fullName)}
              filterTab={valuee}
              loading={loading}
              addedSkills={addedSkill}
              hideTab={hideTab}
              getConsultData={getConsultData1}
              getLocalisedData={getLocalisedData1}
              selectTab={selectTab}
              localisedAll={localisedAll}
            />
          ))}
        </Table>
        {loading !== "" && (
          <Stack sx={{ mt: 2, p: 2 }}>
            <Typography sx={{ alignSelf: 'center', color: 'red' }}>{loading}</Typography>
          </Stack>
        )}

        <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 1 }}>
          {hideBtn > 48 && (

            <Button
              color="custom" variant="contained" size="small"
              onClick={() => handlePage(valuee)}
            >
              Next Batch
            </Button>
          )}
        </Box>

      </TableContainer>

      <Modal open={modalOpen} onClose={handleCloseModal} style={{ borderRadius: 10 }}>
        <Box sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: { xs: '95%', sm: '70%' },
          // width: { xs: '85%', sm: '60%' },
          bgcolor: 'background.paper',
          border: '3px solid #3C6BA5',
          boxShadow: 24,
          p: 3,
          borderRadius: 3,
        }}
        >
          <Typography variant="h5" color={'#3C6BA5'} textAlign={'center'}>
            Send Email
          </Typography>
          <Scrollbar sx={{ maxHeight: 400, Scrollbar: 'thin' }}>
            {/* <Divider sx={{ mb: 2 }} /> */}
            <Grid container spacing={1} mt={1}>
              <Grid item xs={5.9}>
                <TextField
                  fullWidth
                  required
                  label="To"
                  variant="outlined"
                  size="small"
                  // value={to}
                  value={recipientEmail}
                  // onChange={(e) => setTo(e.target.value)}
                  onChange={(e) => setRecipientEmail(e.target.value)}
                />
              </Grid>
              <Grid item xs={5.9}>
                <Autocomplete
                  size='small'
                  multiple
                  id="tags-outlined"
                  onChange={(event, newValue) => {
                    setCcEmail([...newValue]);
                  }}
                  options={[{ title: '' }]}
                  getOptionLabel={(option) => option.title}
                  value={ccEmail.map((item) => item)}
                  filterSelectedOptions
                  filterOptions={(options, params) => {
                    const filtered = filter(options, params);
                    const { inputValue } = params;
                    // Suggest the creation of a new value
                    const isExisting = options.some((option) => inputValue === option.title);
                    if (inputValue !== '' && !isExisting) {
                      filtered.push({
                        inputValue,
                        title: `${inputValue}`,
                      });
                    }
                    return filtered;
                  }}
                  renderInput={(params) => <TextField {...params} label="Cc" placeholder="Cc"

                    size="small"
                  />}
                />
              </Grid>
            </Grid>
            <Grid container spacing={1} mt={1}>
              <Grid item xs={5.9}>
                <Autocomplete
                  multiple
                  size="small"
                  id="tags-outlined"
                  value={bccEmail}
                  onChange={(event, newValue) => {
                    setBccEmail(newValue);
                  }}
                  options={[]}
                  getOptionLabel={(option) => option.email || option.title || ''}
                  isOptionEqualToValue={(option, value) => option.email === value.email}
                  filterSelectedOptions
                  filterOptions={(options, params) => {
                    const { inputValue } = params;

                    const isExisting = bccEmail.some((item) => item.email === inputValue);
                    if (inputValue !== '' && !isExisting) {
                      return [
                        ...options,
                        {
                          name: '',
                          email: inputValue,
                        },
                      ];
                    }

                    return options;
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Others"
                      placeholder="Others"
                      multiline
                      rows={3}
                      size="small"
                      InputProps={{
                        ...params.InputProps,
                        sx: {
                          alignItems: 'flex-start',
                          '& textarea': {
                            textAlign: 'left',
                            paddingTop: '1px !important',
                          },
                        },
                      }}
                    />
                  )}
                />

              </Grid>

<Grid item xs={5} sx={{}}>
                <FormControl variant="outlined" fullWidth size="small" >
                  <InputLabel >Select Template</InputLabel>
                  <Select
                    label="Select Template"
                   
                    onChange={(e) => handleTemplateSelect(e.target.value)}
                  >
                    {tempList?.map((item) => (
                      <MenuItem key={item?.id} value={item}>
                        {item?.templateName}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl> 
              </Grid>

<Typography
                onClick={() => navigate('/Email', { state: { undid: "undid", bodyDis: "bodyDis" } })}
                sx={{
                  color: '#23A6F0',
                  fontWeight: 'bold',
                  fontSize: '17px',
                  marginLeft: '30px',
                  marginTop: '12px',
                  cursor: 'pointer',
                }}
              >
                Edit
              </Typography>

            </Grid>
            {/* <Grid container alignItems="center" style={{ flexDirection: 'row' }}>
              <Grid item xs={12} style={{ display: 'flex', alignItems: 'center' }}>
                <Typography sx={{ ml: 1, color: '#1E74B3' }}>Attachment:</Typography>
                <input type="file" onChange={FileChange} style={{ marginLeft: '9px' }} />

              </Grid>
            </Grid> */}

<Grid container alignItems="center" style={{ flexDirection: 'row' }}>
  <Grid item xs={12} style={{ display: 'flex', alignItems: 'center' }}>
    <Typography sx={{ ml: 1, color: '#1E74B3', whiteSpace: 'nowrap' }}>
      Attachment:
    </Typography>
    <input
      type="file"
      onChange={FileChange}
      style={{
        marginLeft: '9px',
        flex: 1,        
        minWidth: 0,   
      }}
    />
  </Grid>
</Grid>

            <Grid container spacing={1}>
              <Grid item xs={11.8}>
                <TextField
                  label='Sub'
                  variant="outlined"
                  fullWidth
                  margin="normal"
                  size="small"
                  value={subject}
                  onChange={(e) => setSubject(e.target.value)}
                  InputProps={{ style: { borderRadius: '10px', paddingLeft: '5px' } }}
                // InputLabelProps={{ style: { marginLeft: '14px' } }}
                />
              </Grid>
              <Grid item xs={11.8}>
                <Stack sx={{ flexDirection: 'row', gap: 1, alignItems: 'center' }}>

                  <Typography>Hello {'{Name},'}</Typography>
                </Stack>
              </Grid>
              <Grid item xs={11.8}>
                <CKEditor
                  data={emailBody}
                  config={{
    // licenseKey: process.env.REACT_APP_TLK,
    // toolbar: [
    //   'heading', '|',
    //   'bold', 'italic', 'link', '|',
    //   'insertImage', 'undo', 'redo'
    // ],
    extraPlugins: [ MyCustomUploadAdapterPlugin ]
  }}
                  onChange={(event, editor) => {
                    const data = editor.getData();
                    // console.log("body", data)
                    setEmailBody(data);
                  }}
                  editor={ClassicEditor}
                />
              </Grid>
            </Grid>
            <Stack sx={{ mt: 1 }}>

              <div dangerouslySetInnerHTML={{ __html: localStorage.getItem('sign') }} />
            </Stack>

            <Stack flexDirection={'row'} gap={1} mt={1} sx={{ justifyContent: 'center' }}>
              <Button
                color="custom"
                variant="contained"
                // onClick={SendEmail}
                disabled={recipientEmail === '' || subject === '' || loadingSend}
                onClick={() => sendBulkEmail()}>
                {/* Send */}
                {loadingSend ? "Sending" : 'Send'}
              </Button>
            </Stack>
          </Scrollbar>
        </Box>
      </Modal>
    </>
  )
}

export default Foxearch;

function ConsultRow({ index, row, checked1, handleCheck1, filterTab,
  addedSkills, hideTab,
  getConsultData, getLocalisedData, selectTab, localisedAll
}) {

  const navigate = useNavigate()
  const CircleCheckbox = styled(Checkbox)(({ theme }) => ({
    '&.Mui-checked': {
      color: '#1976d2',
      cursor: 'pointer',
    },
    '&.Mui-checked .MuiSvgIcon-root': {
      backgroundColor: '#1976d2',
      borderRadius: '50%',
    },
    '& .MuiSvgIcon-root': {
      borderRadius: '50%',
      width: 23,
      height: 23,
      border: '2px solid #1976d2',
    },
    '&:hover': {
      backgroundColor: 'transparent',
      cursor: 'pointer',
    },
  }));

  const styleClients1 = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: { xs: '40%', sm: '60%' },
    bgcolor: 'background.paper',
    border: '3px solid #3C6BA5',
    boxShadow: 24,
    p: 3,
    borderRadius: 3,
  };

  const styleSkillset1 = {
    position: 'absolute',
    top: '50%',
    left: '55%',
    transform: 'translate(-50%, -50%)',
    width: { xs: '30%', sm: '50%' },
    bgcolor: 'background.paper',
    border: '3px solid #3C6BA5',
    boxShadow: 24,
    p: 3,
    borderRadius: 3,
  };

  const styleSkillset11 = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: { xs: '50%', sm: '70%' },
    bgcolor: 'background.paper',
    border: '3px solid #3C6BA5',
    boxShadow: 24,
    p: 3,
    // paddingTop:3,
    // paddingBottom:3,
    borderRadius: 3,
  };

  // console.log(" rec row====>>>+++", row)
  // console.log("row.resumeUrl[0]===>>>>>>>", row.additionalResumes)

  const styleClients = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: { xs: '60%', sm: '80%' },
    bgcolor: 'background.paper',
    border: '3px solid #3C6BA5',
    boxShadow: 24,
    p: 3,
    borderRadius: 3,
  };

  const optionsDate = {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    // timeZone: 'UTC'
  };

  const optionsTime = {
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
    // timeZone: 'UTC'
  };

  const [opens, setOpens] = useState(false);
  const handleOpens = () => setOpens(true);
  const handleCloses = () => setOpens(false);

  const [addSkill, setAddSkill] = useState(false);
  const handleSkillOpen = () => setAddSkill(true);
  const handleSkillClose = () => setAddSkill(false);

  const [newSkill, setNewSkill] = useState([])
  const [details1, setDetails1] = useState([])
  // console.log("details1", details1)

  const [details2, setDetails2] = useState([])
  // console.log("details2", details2)

  const [details3, setDetails3] = useState([])
  // console.log("details3", details3)

  const [details4, setDetails4] = useState([])
  // console.log("details4", details4)

  // console.log("<<<<<<<< >>>>> newSkill", newSkill)

  const [skillss, setSkillss] = useState([])
  // console.log("skillss", skillss)

  const validSkills = row.skill.filter(item => item !== '' && item !== null);
  const validSkills1 = newSkill.filter(item => item !== '' && item !== null);

  const [hideButton, setHideButton] = useState(true)
  const [hideCross, setHideCross] = useState(true)

  const handleDeleteSkill = (index) => {
    // console.log("===============indx", index)
    // console.log("====validSkills", validSkills)

    const arrr = validSkills?.filter((_, i) => i !== index);
    const arrr1 = validSkills1?.filter((_, i) => i !== index);
    // console.log("arrr", arrr1)
    setNewSkill(arrr1)
  }

  const [loading12, setLoading12] = useState(false);

  const deleteSkill = async () => {
    setLoading12(true)
    // console.log('===========update', newSkill);
    const updatedSkill = [];
    newSkill?.map((item) => {
      return updatedSkill?.push(item);
    });
    // console.log('=======after map skill', updatedSkill);

    const token = localStorage.getItem('token');
    const body = {
      // "newCV": "no",
      // resumeId: details4,
      bench_id: details4,
      fullName: details1,
      email: details2,
      jobTitle: details3,
      skill: updatedSkill,
    };

    // Api(`resume/update_resume`, 'POST', body, token)
    Api(`bench/updateBenchworksheet`, 'POST', body, token)
      .then((Response) => {
        // console.log('======getUser==response=====>', Response);
        if (Response.status === 200) {
          toast.success(Response.data.message);
          // fun();
          if (Response.data.code === 200) {
            toast.success(Response.data.message);
            // fun();
            setLoading12(false)
            // console.log('=====>', Response);
            setHideButton(true)
            setHideCross(true)
            // console.log('=====>', Response);
          } else {
            // console.log('+++======>', +Response);
            toast.warn(Response.data.message);
            // enqueueSnackbar(Response.data.message);
          }
        }
      })
      .catch((err) => {
        toast.error(err, +'!');
        // console.log('===========', err);
      });
  };

  const [loading11, setLoading11] = useState(false);

  const AdddSkill = async () => {
    setLoading11(true)
    // console.log('===========update', skillss);
    const updatedSkill = [];

    skillss?.forEach((item) => {
      const lowerCaseSkill = item.title?.toLowerCase();
      if (!newSkill?.map(skill => skill?.toLowerCase())?.includes(lowerCaseSkill)) {
        updatedSkill?.push(item.title);
      }
    });

    const combinedSkills = [...newSkill, ...updatedSkill];
    const uniqueSkills = [...new Set(combinedSkills?.map(skill => skill?.toLowerCase()))];

    const token = localStorage.getItem('token');
    const body = {
      // "newCV": "no",
      bench_id: details4,
      fullName: details1,
      email: details2,
      jobTitle: details3,
      skill: uniqueSkills,
    };

    // Api(`resume/update_resume`, 'POST', body, token)
    Api(`bench/updateBenchworksheet`, 'POST', body, token)
      .then((Response) => {
        // console.log('======getUser==response=====>', Response);
        if (Response.status === 200) {
          toast.success(Response.data.message);
          // fun();
          handleCloses()
          setLoading11(false)
          handleSkillClose();
          // handleCloses()
          setSkillss([]);
          if (Response.data.code === 200) {
            toast.success(Response.data.message);
            // fun();
            handleCloses()
            setLoading11(false)
            handleSkillClose();
            // handleCloses()
            setSkillss([]);
            // console.log('=====>', Response);
          } else {
            // console.log('+++======>', +Response);
            toast.warn(Response.data.message);
            // enqueueSnackbar(Response.data.message);
          }
        }
      })
      .catch((err) => {
        toast.error(err, +'!');
        // console.log('===========', err);
      });
  };

  const [openclient1, setOpenclient1] = useState(false);
  const [EditSumId, setEditSumId] = useState()

  const [enableEditSum, setEnableEditSum] = useState(false)
  const handleOpenclient1 = (row) => {
    setUpdateSummary(row.summary);
    setOpenclient1(true)
    if (filterTab === "worksheet") {
      setEditSumId(row._id)
    } else {
      setEditSumId(row.benchId)
    }
  }

  const handleCloseclient1 = () => setOpenclient1(false);
  const [updateSummary, setUpdateSummary] = useState('')
  const [loadingSum, setLoadingSum] = useState(false)
  const [checkRow, setCheckRow] = useState()

  const selectCheckBox = (id, email, fullName) => {
    // console.log("fullname", fullName)
    // setCheckRow(row)
    handleCheck1(id, email, fullName)
  }
  // console.log("checkRow", checkRow)

  const getHis = () => {
    const token = localStorage.getItem('token');
    Api(`resume/get_history/${filterTab !== 'consult' ? row._id : row.resumeId}`, 'GET', '', token)
      .then((response) => {
        // console.log('==========get_history=====>>>', response);
        if (response.status === 200) {
          if (response.data.code === 200) {
            setHis(response.data.data);
            // setJoblst(response.data.data);
          }
        }
      })
      .catch((err) => { });
  };

  const handleClosen = () => setOpenn(false);

  const [openn, setOpenn] = useState(false);
  const [his, setHis] = useState([]);
  const handleOpenn = () => {
    setOpenn(true);
    getHis();
  };

  const [openclient, setOpenclient] = useState(false);
  const handleOpenclient = () => setOpenclient(true);
  const handleCloseclient = () => setOpenclient(false);

  const [client, setClients] = useState([]);
  const getClients = async () => {
    const token = localStorage.getItem('token');
    let id;
    if (filterTab !== 'consult') {
      id = row._id
    }
    else {
      id = row.resumeId
    }
    // console.log("==========id", id)

    Api(`resume/get_history/${id}`, 'GET', '', token)
      .then((response) => {
        if (response.status === 200) {
          // console.log('=========get_client_for_resume======>>>>>>>', response);
          if (response.data.code === 200) {
            setClients(response.data.data);
            // console.log('client========', JSON.stringify(response.data));
            handleOpenclient();
          } else {
            // toast.error(response.data.message, +'!');
          }
        }
      })
      .catch((err) => {
        // console.log('===========', err);
        // toast.error(err, +'!');
      });
  };

  const styleClients11 = {
    height: "90%",
    position: 'absolute',
    top: '53%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: { xs: '45%', sm: '65%' },
    bgcolor: 'background.paper',
    border: '3px solid #3C6BA5',
    boxShadow: 24,
    p: 3,
    borderRadius: 3,
  };

  const [openRes, setOpenRes] = useState('');
  const [openR, setOpenR] = useState(false);

  const openResume = (resUrl) => {
    setOpenRes(resUrl)
    setOpenR(true);
  };
  const closeResume = () => {
    setOpenR(false);
  };

  const suru = 'https://docs.google.com/viewer?url=';
  const lll = '&embedded=true';

  const [ResumeDatabaseId, setResumeDataBaseId] = useState()
  const [openConfirmDelete, setOpenConfirmDelete] = useState(false);
  const confirmCloseDelete = () => setOpenConfirmDelete(false);
  const confirmOpenDelete = (id) => {
    setResumeDataBaseId(id)
    setOpenConfirmDelete(true);
  }
  const [reason, setReason] = useState()

  const styless = {
    position: 'absolute',
    top: '48%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: { md: '50%', xs: '95%' },
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 3,
    border: '3px solid #3C6BA5',
    borderRadius: 3,
  };

  const spamData = () => {
    const body = {
      "database_id": ResumeDatabaseId,
      "reason": reason
    }
    const token = localStorage.getItem('token');
    Api('database/reportTheData', 'POST', body, token).then((Response) => {
      // console.log("Response.data")
      if (Response.status === 200) {
        if (Response.data.status === 200) {
          // foxDBSearchAuto(lastSearch, '')
          if (filterTab === "consult") {
            getConsultData()

          } else {
            // getConsultData()
            localisedAll()
            // selectTab(filterTab)
          }
          toast.success(Response.data?.resmessage)
          confirmCloseDelete()
          setReason('')
        }
      } else {
        toast.warn(Response.data?.resmessage)
      }
    })
  }

  return (

    <>
      <TableRow
        key={row._id}
        sx={[
          { background: index % 2 === 0 ? 'text.background' : tablebg },
          { '&:last-child td, &:last-child th': { border: 0 } },

          { '&:hover': { boxShadow: 5 } },
        ]}
      >
        <TableCell sx={{}}>
          <Stack sx={{ flexDirection: "row" }}>

            {/* <Stack sx={{ flexDirection: "column", mt: -1 }}>
              <FormControlLabel
                control={<Checkbox checked={checked1 || false} onClick={()=>selectCheckBox(row?._id)} />}
                label=""
              />
              {row?.dataFrom === "foxearchDB" ? (

                <Iconify
                  icon="fluent:prohibited-32-regular"
                  width="1.4rem"
                  color="red"
                  sx={{ cursor: "pointer", ml: -0.2 }}
                  onClick={() => confirmOpenDelete(row?._id)}
                />
              ):(
""
              )}
            </Stack> */}

            <Stack
              sx={{
                flexDirection: "column",
                mt: -1,
                cursor: "pointer",
              }}
            //  onChange={() => selectCheckBox(row?._id, row?.email)}
            >
              <FormControlLabel
                control={
                  <Checkbox
                    checked={checked1 || false}
                    onChange={() => selectCheckBox(row?._id, row?.email, row?.benchAppId?.fullName || row?.recruitorAppId?.fullName)}
                  />
                }
                label=""
              />
              {row?.dataFrom === "foxearchDB" ? (
                <Iconify
                  icon="fluent:prohibited-32-regular"
                  width="1.4rem"
                  color="red"
                  sx={{ cursor: "pointer", ml: -0.2 }}
                  onClick={(e) => {
                    e.stopPropagation();
                    confirmOpenDelete(row?._id);
                  }}
                />
              ) : (
                ""
              )}
            </Stack>


            <Stack sx={{ flexDirection: "column" }}>
              <Typography sx={{ color: 'text.secondary' }}>
                Up - {`${new Date(row?.benchAppId?.updatedAt || row?.recruitorAppId?.updatedAt || row?.updatedAt)?.toLocaleString('en-US', optionsDate)}
          ${String(new Date(row?.benchAppId?.updatedAt || row?.recruitorAppId?.updatedAt || row?.updatedAt)?.getHours())?.padStart(2, '0')}`}:
                {`${String(new Date(row?.benchAppId?.updatedAt || row?.recruitorAppId?.updatedAt || row?.updatedAt)?.getMinutes())?.padStart(2, '0')}`}
              </Typography>
              <Typography>-</Typography>
              <Typography>
                Cr - {`${new Date(row?.benchAppId?.createdAt || row?.recruitorAppId?.createdAt || row?.updatedAt)?.toLocaleString('en-US', optionsDate)}
          ${String(new Date(row?.benchAppId?.createdAt || row?.recruitorAppId?.createdAt || row?.updatedAt)?.getHours())?.padStart(2, '0')}`}:
                {`${String(new Date(row?.benchAppId?.createdAt || row?.recruitorAppId?.createdAt || row?.updatedAt)?.getMinutes())?.padStart(2, '0')}`}
              </Typography>
            </Stack>
          </Stack>
        </TableCell>





        <TableCell sx={{ paddingTop: 0, paddingBottom: 0 }}>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              maxWidth: '100%',
            }}
          >
            <Typography
              sx={{
                color: 'text.secondary',
                fontWeight: '600',
                fontSize: '0.9rem',
                maxWidth: 180,
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                cursor: 'pointer',
                textTransform: 'capitalize'
              }}
              onClick={() => {
                const fTab = filterTab === 'worksheet' ? 'submitted' : '';
                if (filterTab === 'consult') {
                  navigate('/benchresumedetails', {
                    state: {
                      addedSkills,
                      row,
                      mtab: 'Resume',
                      fTab,
                    },
                  });
                } else {
                  navigate('/resumeDetail', {
                    state: {
                      addedSkills,
                      row,
                      mtab: 'Resume',
                      fTab,
                    },
                  });
                }
              }}
            >
              {row?.benchAppId?.fullName || row?.recruitorAppId?.fullName || row?.fullName || '-'}
            </Typography>

            <Iconify
              icon="devicon:linkedin"
              color={'text.textG'}
              sx={{
                ml: 1,
                height: 17,
                width: 17,
                cursor: 'pointer',
                mb: -0.5,
              }}
              hover
              onClick={() =>
                window.open(row?.benchAppId?.linkedinUrl || row?.recruitorAppId?.linkedinUrl || row?.linkedinUrl, '_blank')
              }
            />

            <Iconify
              icon="cuida:document-text-outline"
              color="#1E74B3"
              sx={{
                ml: 0.6,
                height: 18,
                width: 18,
                mb: -0.4,
                cursor: 'pointer',
              }}
              hover
              onClick={() =>
                openResume(row?.benchAppId?.resumeUrl || row?.recruitorAppId?.resumeUrl || row?.resumeUrl)
              }
            />
          </Box>

          <Typography sx={{ maxWidth: 180, overflow: 'hidden', textOverflow: 'ellipsis' }} >
            {row?.benchAppId?.currentCompany ||
              row?.recruitorAppId?.currentCompany || row?.currentCompany || "-"}
          </Typography>
          <Typography sx={{ maxWidth: 180, overflow: 'hidden', textOverflow: 'ellipsis' }} >
            {row?.benchAppId?.jobTitle ||
              row?.recruitorAppId?.jobTitle || row?.jobTitle || "-"
            }
          </Typography>
        </TableCell>



        
        <TableCell sx={{ paddingTop: 0, paddingBottom: 0 }}>
          {filterTab === "consult" ? (
            <>  
              <Typography
                sx={{ maxWidth: 180, overflow: 'hidden', textOverflow: 'ellipsis' }}>
                {row?.addedById?.contactNo ||
                  row?.addedById?.contactNo || "-"
                }
                {/* {row?.benchAppId?.phone ||
                  row?.recruitorAppId?.phone || row?.phone || "-"
                } */}
              </Typography>
              <Typography sx={{ maxWidth: 180, overflow: 'hidden', textOverflow: 'ellipsis' }} >
                {row?.addedById?.email ||
                  row?.addedById?.email || "-"
                }
                {/* {row?.benchAppId?.email ||
                  row?.recruitorAppId?.email || row?.email || "-"
                } */}
              </Typography>
              <Stack sx={{ flexDirection: 'row', gap: 0.5, maxWidth: 160, overflow: 'hidden', textOverflow: 'ellipsis' }}>
                <Typography >
                  {
                    (row?.benchAppId?.city || row?.benchAppId?.stateCode)
                      ? `${row?.benchAppId?.city}, ${row?.benchAppId?.stateCode}`
                      : (row?.recruitorAppId?.city || row?.recruitorAppId?.stateCode
                        ? `${row?.recruitorAppId?.city}, ${row?.recruitorAppId?.stateCode || '-'}`
                        : (row?.city || row?.stateCode
                          ? `${row?.city}, ${row?.stateCode || '-'}`
                          : '-')
                      )
                  }

                </Typography>
                {row?.relocation === 'yes' ? (
                  <Iconify icon="mdi:aeroplane" fontSize={19} color={'text.secondary'} />
                ) : ''}
              </Stack>
            </>
          ) : (
            <>
              <Typography
                sx={{ maxWidth: 180, overflow: 'hidden', textOverflow: 'ellipsis' }}>
                {row?.benchAppId?.phone ||
                  row?.recruitorAppId?.phone || row?.phone || "-"
                }
              </Typography>
              <Typography sx={{ maxWidth: 180, overflow: 'hidden', textOverflow: 'ellipsis' }} >
                {row?.benchAppId?.email ||
                  row?.recruitorAppId?.email || row?.email || "-"
                }
              </Typography>
              <Stack sx={{ flexDirection: 'row', gap: 0.5, maxWidth: 160, overflow: 'hidden', textOverflow: 'ellipsis' }}>
                <Typography >
                  {
                    (row?.benchAppId?.city || row?.benchAppId?.stateCode)
                      ? `${row?.benchAppId?.city}, ${row?.benchAppId?.stateCode}`
                      : (row?.recruitorAppId?.city || row?.recruitorAppId?.stateCode
                        ? `${row?.recruitorAppId?.city}, ${row?.recruitorAppId?.stateCode || '-'}`
                        : (row?.city || row?.stateCode
                          ? `${row?.city}, ${row?.stateCode || '-'}`
                          : '-')
                      )
                  }
                </Typography>
                {row?.relocation === 'yes' ? (

                  <Iconify icon="mdi:aeroplane" fontSize={19} color={'text.secondary'} />
                ) : ''}
              </Stack>
            </>
          )}

        </TableCell>













        <TableCell sx={{ width: 190, paddingTop: 0, paddingBottom: 0 }}>
          {row?.benchAppId?.skill || row?.recruitorAppId?.skill || row?.skill && (row?.benchAppId?.skill.length > 0 ||
            row?.recruitorAppId?.skill.length > 0 || row?.skill.length > 0) ? (
            <Grid container sx={{ maxWidth: 160, height: 44, overflow: 'hidden', textOverflow: 'ellipsis', gap: 0.3 }}>

              {(row?.benchAppId?.skill || row?.recruitorAppId?.skill || row?.skill)?.slice(0, 3).map((item, index, arr) => (
                item && (
                  <Typography key={index} sx={{ display: 'inline' }}>
                    {item}
                    {index < arr.length - 1 && ' | '}
                  </Typography>
                )
              ))}
            </Grid>
          ) : (
            <Typography>-</Typography>
          )}

          {/* {(row?.benchAppId?.skill || row?.recruitorAppId?.skill || row?.skill)?.length > 0 ? ( */}
          <Typography
            sx={{ color: 'text.secondary', textDecoration: 'underline', cursor: 'pointer' }}
            onClick={() => {
              handleOpens();
              setNewSkill(row?.benchAppId?.skill || row?.recruitorAppId?.skill || row?.skill);
              setDetails1(row?.benchAppId?.fullName || row?.recruitorAppId?.fullName);
              setDetails2(row?.benchAppId?.email || row?.recruitorAppId?.email);
              setDetails3(row?.benchAppId?.jobTitle || row?.recruitorAppId?.jobTitle);
              setDetails4(row?.benchAppId?._id || row?.recruitorAppId?._id);
            }}
          >
            view all
          </Typography>

        </TableCell>















        <TableCell sx={{ width: 110, overflow: 'hidden', textOverflow: 'ellipsis', paddingTop: 0, paddingBottom: 0 }}>
          <>
            <Box sx={{ display: 'flex', alignItems: 'center', mt: -0.6, color: 'text.secondary' }}>
              <Typography sx={{ paddingRight: 1 }}>
                {row?.benchAppId?.visaType || row?.recruitorAppId?.visaType || row?.visaType ? row?.benchAppId?.visaType || row?.recruitorAppId?.visaType || row?.visaType : '-'}
              </Typography>
              {row?.benchAppId?.visaTransfer || row?.recruitorAppId?.visaTransfer || row?.visaTransfer === "yes" ? (
                <Iconify icon="fluent:arrow-swap-16-filled" width="1.1rem" />
              ) : null}
            </Box>
            {/* <Typography sx={{}}>
              {row?.benchAppId?.offeredJob || row?.recruitorAppId?.offeredJob || row?.offeredJob &&
                (row?.benchAppId?.annualSalary || row?.recruitorAppId?.annualSalary || row?.annualSalary
                  || row?.benchAppId?.hourlyRateRateOffered || row?.recruitorAppId?.hourlyRateRateOffered || row?.hourlyRateRateOffered)
                && (
                  <>
                    ${row?.benchAppId?.offeredJob || row?.recruitorAppId?.offeredJob || row?.offeredJob === 'fulltime' ? row?.benchAppId?.annualSalary || row?.recruitorAppId?.annualSalary || row?.annualSalary
                      : row?.benchAppId?.hourlyRateRateOffered || row?.recruitorAppId?.hourlyRateRateOffered || row?.hourlyRateRateOffered}
                    {row?.benchAppId?.chargeType || row?.recruitorAppId?.chargeType || row?.chargeType === 'hourly' ? '/Hour' : 'K'}
                  </>
                )}
            </Typography> */}
            <Typography sx={{}}>
              {row?.benchAppId?.expectedCompensation || row?.recruitorAppId?.expectedCompensation || row?.expectedCompensation ? (
                <>
                  ${row?.benchAppId?.expectedCompensation || row?.recruitorAppId?.expectedCompensation || row?.expectedCompensation}
                  {(
                    row?.benchAppId?.chargeType === 'hourly' ||
                    row?.recruitorAppId?.chargeType === 'hourly' ||
                    row?.chargeType === 'hourly'
                  ) ? '/Hour' : 'K'}
                </>
              ) : null}
            </Typography>

            <Typography sx={{ textTransform: "capitalize" }} color={'text.textG'}>
              {row?.benchAppId?.taxTerm || row?.recruitorAppId?.taxTerm || row?.taxTerm ? row?.benchAppId?.taxTerm || row?.recruitorAppId?.taxTerm || row?.taxTerm : '-'}
            </Typography>
          </>
        </TableCell>

        {filterTab === "consult" &&

          <>
            <TableCell sx={{ paddingTop: 0, paddingBottom: 0 }}>

              <Typography sx={{ color: 'text.secondary', textDecoration: 'underline', cursor: 'pointer' }}
                onClick={() => handleOpenclient1(row)}>

                Summary
              </Typography>
              <Typography>{"Exp - "}{row.experienceInYear || row?.benchAppId?.experienceInYear || row?.benchAppId?.experienceInYear}{" Yrs"}</Typography>
              <Typography sx={{ color: 'text.secondary' }}>
                {row.DOB || row?.benchAppId?.DOB || row?.benchAppId?.DOB ? (
                  <>
                    D.O.B - {moment(row.DOB || row?.benchAppId?.DOB || row?.benchAppId?.DOB).format('ll')}
                  </>
                ) : (
                  '-'
                )}
              </Typography>
            </TableCell>
          </>
        }







        <Modal open={openclient} onClose={handleCloseclient} style={{ borderRadius: 10 }}>
          <Box sx={styleClients}>
            <Typography variant="h5" color={'#3C6BA5'} textAlign={'center'}>
              Activities
            </Typography>
            <Divider sx={{ mb: 2 }} />
            <Scrollbar sx={{ maxHeight: 400, Scrollbar: 'thin' }}>
              <Stack sx={{ alignItems: 'center' }}>
                <Stack sx={{ backgroundColor: 'text.secondary', width: '100%', alignItems: 'center', p: 0.5, borderRadius: 1 }}>
                  <Stack
                    sx={{ width: '100%', flexDirection: 'row', justifyContent: 'space-between' }}
                  >
                    <Typography sx={{ width: '25%', color: 'white', fontSize: '0.976rem', fontWeight: '600' }}>
                      Date
                    </Typography>
                    <Typography sx={{ width: '20%', color: 'white', fontSize: '0.976rem', fontWeight: '600' }}>
                      User Name
                    </Typography>
                    <Typography sx={{ width: '20%', color: 'white', fontSize: '0.976rem', fontWeight: '600' }}>
                      Job ID
                    </Typography>
                    <Typography sx={{ width: '20%', color: 'white', fontSize: '0.976rem', fontWeight: '600' }}>
                      Client
                    </Typography>
                    <Typography sx={{ width: '20%', color: 'white', fontSize: '0.976rem', fontWeight: '600' }}>
                      Job Title
                    </Typography>
                    <Typography sx={{ width: '20%', color: 'white', fontSize: '0.976rem', fontWeight: '600' }}>
                      Status
                    </Typography>
                  </Stack>
                </Stack>

                {client
                  ? client.map((item, index) => {
                    // console.log('client list----------------------', item);
                    return (
                      <Stack
                        sx={[
                          { background: index % 2 === 0 ? 'text.background' : tablebg },
                          { width: '100%', flexDirection: 'row', justifyContent: 'space-between', p: 1 },
                        ]}
                      >
                        <Typography sx={{ width: '25%' }}>
                          {/* {moment(`${item.createdAt}`).format('lll')} */}
                          {`${new Date(item.createdAt).toLocaleString('en-US', optionsDate)} 
  ${String(new Date(item?.createdAt).getHours()).padStart(2, '0')}:${String(new Date(item?.createdAt).getMinutes()).padStart(2, '0')}`}
                        </Typography>
                        <Typography sx={{ width: '20%', textTransform: 'capitalize', fontWeight: '800', color: 'text.secondary' }}>
                          {item.actionBy}
                        </Typography>
                        <Typography sx={{ width: '20%', textTransform: 'capitalize' }}>
                          {item.jobId ? item.jobId : '-'}
                        </Typography>
                        <Typography sx={{ width: '20%', textTransform: 'capitalize' }}>
                          {item.clientName ? item.clientName : '-'}
                        </Typography>
                        <Typography sx={{ width: '20%', textTransform: 'capitalize' }}>
                          {item.jobIdTitle || item.jobTitle}
                        </Typography>
                        <Typography
                          sx={[
                            {
                              color:
                                item.actionTo === 'started' || item.actionTo === 'placement'
                                  ? 'green'
                                  : item.actionTo === 'Backout from Job offer'
                                    ? 'red'
                                    : '',
                            },
                            { width: '20%', textTransform: 'capitalize' },
                          ]}
                        >
                          {item.actionTo}
                        </Typography>
                      </Stack>
                    );
                  })
                  : null}
              </Stack>
            </Scrollbar>
          </Box>
        </Modal>

        <Modal open={openn} onClose={handleClosen} style={{ borderRadius: 10 }}>
          <Box sx={styleClients}>
            {/* <Stack sx={{ width: '100%', alignItems: 'flex-end' }}>
            <Button
              // sx={{width:'13%'}}
              color="custom"
              variant="contained"
              size="small"
              onClick={() =>
                navigate('/resumeDetail', {
                  state: {
                    addedSkills,
                    row,
                    mtab: 'Resume',
                    fTab:
                      filterTab === 'worksheet'
                        ? 'submitted'
                        : '' || filterTab === 'favourites'
                          ? 'submitted'
                          : '' || filterTab === 'interview'
                            ? 'placement'
                            : '' || filterTab === 'placement'
                              ? 'start'
                              : '',
                  },
                })
              }
            >
              Add Note
             
            </Button>
          </Stack> */}
            <Typography variant="h5" color={'#3C6BA5'} sx={{ textTransform: 'capitalize', mt: -3 }} textAlign={'center'}>
              {/* {row.fullName.split(" ",1)}'s Notes */}
              {/* {row.fullName}'s Notes */}
              {/* {/\s/.test(row.fullName) ? row.fullName.split(" ", 1) : row.fullName}'s  */}
              Notes
            </Typography>
            <Divider sx={{ mb: 2 }} />
            <Scrollbar sx={{ maxHeight: 400, Scrollbar: 'thin' }}>
              <Stack sx={{ backgroundColor: 'text.secondary', flexDirection: 'row', p: 1, py: 0.5, borderRadius: 1 }}>
                <Typography color={'white'} sx={{ width: '16%', fontSize: '0.976rem', fontWeight: '600' }}>
                  Date
                </Typography>
                <Typography color={'white'} sx={{ width: '10%', fontSize: '0.976rem', fontWeight: '600' }}>
                  User
                </Typography>
                <Typography color={'white'} sx={{ width: '80%', fontSize: '0.976rem', fontWeight: '600' }}>
                  Note
                </Typography>
              </Stack>
              {his.length
                ? his.map((item, index) => {
                  return (
                    <Stack
                      sx={[
                        { background: index % 2 === 0 ? 'text.background' : tablebg },
                        { flexDirection: 'row', p: 1 },
                      ]}
                    >
                      <Typography sx={{ width: '16%' }}>
                        {/* {moment(`${item.createdAt}`).format('lll')} */}
                        {`${new Date(item.createdAt).toLocaleString('en-US', optionsDate)} 
  ${String(new Date(item?.createdAt).getHours()).padStart(2, '0')}:${String(new Date(item?.createdAt).getMinutes()).padStart(2, '0')}`}
                      </Typography>
                      <Typography sx={{ width: '10%', textTransform: 'capitalize', fontWeight: '800', color: 'text.secondary' }}>{item.actionBy}</Typography>
                      <Typography sx={{ width: '80%' }}>
                        {item.note}
                        {/* <div dangerouslySetInnerHTML={{ __html: item.note }} /> */}
                      </Typography>
                    </Stack>
                  );
                })
                : null}
            </Scrollbar>
          </Box>
        </Modal>

        <Modal open={openclient1} onClose={handleCloseclient1} style={{ borderRadius: 10 }}>
          <Box sx={styleClients1}>
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              sx={{ width: '100%' }}
            >
              <Typography
                variant="h5"
                color={'#3C6BA5'}
                textAlign={'center'}
                sx={{ flexGrow: 1, textAlign: 'center' }}
              >
                {/* {row.fullName}'s  */}
                Summary
              </Typography>
              {/* {!enableEditSum && (

  <Button color="custom" variant="contained" onClick={(e)=>setEnableEditSum(true)}>
    Edit
  </Button>
  )}  */}
              {enableEditSum && (
                <Button color="custom" variant="contained" size="small" disabled={loadingSum}
                // onClick={(e)=>editSummary()}
                >
                  {loadingSum ? <CircularProgress size={22} /> : 'Save'}

                </Button>
              )
              }
            </Stack>

            <Divider sx={{ mt: 1, mb: 1, borderWidth: 1.7, borderColor: '#3C6BA5' }} />
            {!enableEditSum && (

              <Typography sx={{ width: '100%', fontSize: '0.976rem', fontWeight: '100' }}>
                {row.summary}
              </Typography>
            )}
            {enableEditSum && (

              <TextField
                sx={{}}
                id="outlined-multiline-static"
                label="Summary"
                multiline
                rows={4}
                width="100%"
                fullWidth
                value={updateSummary}
                onChange={(e) => setUpdateSummary(e.target.value)}

              />
            )}
          </Box>
        </Modal>






        <Modal open={opens} onClose={handleCloses} style={{ borderRadius: 10 }}>
          <Box sx={styleSkillset11}>
            <Stack sx={{ float: "right" }} direction="row" spacing={1.9}>
            
              {!hideButton && (

                <Button color="custom" variant="contained" onClick={() => { deleteSkill() }}
                  disabled={loading12}
                >
                  {/* Save */}
                  {loading12 ? <CircularProgress size={24} /> : 'Save'}
                </Button>
              )}
            </Stack>
            <Typography variant="h5" color={'#3C6BA5'} sx={{ ml: "46%" }}>
              Skills

            </Typography>

            <Scrollbar sx={{ maxHeight: 600, Scrollbar: 'thin' }}>
              <Divider sx={{ mt: 0.5, borderWidth: 1.7, borderColor: '#3C6BA5' }} />
              <Stack
                sx={{
                  flexDirection: 'row',
                  justifyContent: 'center',
                  gap: 0.5,


                  flexWrap: 'wrap'
                }}
              >
                {/* {row.skill?.map((item, index) => (
        item && (
          <Typography
            key={index}
            variant="h6"
            color="text.textG"
            textAlign="center"
            sx={{ mt: 2 }}
          >
            {item}
            {index < row.skill.filter(skill => skill).length - 1 && ' | '}
          </Typography>
        )
      ))} */}

                {/* {row.skill?.map((item, index) => ( */}
                {newSkill?.filter(item => item !== '' && item != null).map((item, index) => (

                  item && (
                    <Box
                      key={index}
                      sx={{
                        position: 'relative',
                        display: 'inline-flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        mt: 2,
                      }}
                    >
                      <Typography
                        variant="h6"
                        color="text.textG"
                        textAlign="center"
                        textTransform="capitalize"
                        sx={{ paddingRight: '2px', position: 'relative', paddingTop: '-3px' }}
                      >
                        {item} {index < row.skill.length - 1 && '|'}

                        {!hideCross && (
                          <Iconify
                            icon="system-uicons:cross-circle"
                            width="1.45rem"
                            height="1.45rem"
                            sx={{
                              position: 'absolute',
                              top: '-15px',
                              right: '1px',
                              cursor: 'pointer',
                              color: 'red',
                            }}
                            onClick={() => handleDeleteSkill(index)}
                          />
                        )}

                      </Typography>
                    </Box>
                  )
                ))}

              </Stack>
            </Scrollbar>
          </Box>
        </Modal>










        <Modal open={addSkill} onClose={handleSkillClose} sx={{ borderRadius: 10 }}>
          <Box sx={styleSkillset1}>
            <Stack spacing={3}>
              <Autocomplete
                multiple
                id="tags-outlined"
                onChange={(event, newValue) => {
                  setSkillss([...newValue]);
                }}
                options={addedSkills}
                getOptionLabel={(option) => option.title}
                value={skillss}
                filterSelectedOptions
                filterOptions={(options, params) => {
                  const filtered = filter(options, params);
                  const { inputValue } = params;

                  const isExisting = options.some((option) => inputValue === option.title);
                  if (inputValue !== '' && !isExisting) {
                    filtered.push({
                      inputValue,
                      title: `${inputValue}`,
                    });
                  }
                  return filtered;
                }}
                renderInput={(params) => (
                  <TextField {...params} label="Skills" placeholder="Enter Skill" autoFocus />
                )}
              />
              <Stack direction="row" justifyContent="center" spacing={3}>
                <Button
                  color="custom"
                  variant="contained"
                  onClick={() => {
                    // handleSkillClose();
                    // handleCloses()
                    // setSkillss([]);
                    AdddSkill()
                  }}
                  disabled={loading11}
                >
                  {/* Add Skill */}
                  {loading11 ? <CircularProgress size={24} /> : 'Add Skill'}
                </Button>
              </Stack>
            </Stack>
          </Box>
        </Modal>

        <Modal open={openR} onClose={closeResume} style={{ borderRadius: 10 }}>
          <Box sx={[styleClients11]}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%', mt: -2.5 }}>
              <Typography variant="h6" sx={{
                textAlign: 'center', color: 'text.secondary', fontWeight: 'bold', flex: 1,
                mb: 1, mt: 1
              }}>
                Resume
              </Typography>
              <a href={openRes} download>
                <Iconify icon="mdi:download" width="1.3rem" color='text.secondary' />
              </a>
            </Box>
            <Scrollbar sx={{ height: "97%", Scrollbar: 'thin', border: '2px solid #3C6BA5', borderColor: 'text.secondary', borderRadius: 2 }}>
              {/* <Divider /> */}
              <Stack sx={{ p: 1.5 }}>
                <iframe title="resume" src={suru + openRes + lll} width="100%" height="700px" />
              </Stack>
            </Scrollbar>
          </Box>
        </Modal>

        <Modal open={openConfirmDelete} onClose={confirmCloseDelete} style={{ borderRadius: 10 }}>
          <Box sx={[styless, { width: '20%' }]}>
            <Stack sx={{ justifyContent: "center", alignContent: 'center', width: '100%' }}>
              <Stack sx={{ width: "100%" }}>
                <TextField
                  label="Reason"
                  variant="outlined"
                  // size="small"
                  fullWidth
                  value={reason}
                  onChange={(e) => setReason(e.target.value)}
                />
              </Stack>
              <Stack sx={{
                flexDirection: 'row', justifyContent: 'space-between',
                width: '25%', mt: 3, alignSelf: 'center', gap: 3
              }}>
                <Button color="custom" sx={{}} variant="contained"
                  onClick={() => spamData()}
                >
                  Submit
                </Button>
                <Button color="custom" sx={{}} variant="contained" onClick={confirmCloseDelete}>
                  Close
                </Button>
              </Stack>
            </Stack>

          </Box>
        </Modal>

      </TableRow>
    </>
  );
};